import { oc } from '@orpc/contract';
import { templateVersionSchema, updateTemplateDraftVersionInputSchema } from '../schemas/templates.schemas.js';
/** Saves the draft values. `expectedRevision` makes a second editor's blind overwrite impossible. */
export const updateTemplateDraftVersionContract = oc
    .route({
    method: 'POST',
    path: '/templates/versions/{versionId}',
    tags: ['Templates'],
    summary: 'Save the draft template version',
})
    .input(updateTemplateDraftVersionInputSchema)
    .output(templateVersionSchema);
//# sourceMappingURL=update-template-draft-version.contract.js.map